/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import React from 'react';
import descriptors from '../../../locales/en-US/descriptors';
import { IObject } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { ICommomGrapgh } from '../PerformanceGraph/IPerformanceGraph';
import PerformanceGraph from '../PerformanceGraph/PerformanceGraph';
import PerformanceGraphNILM from '../PerformanceGraph/PerformanceGraphNILM';
import { MAGIC_VALUE } from '../Utils/Constants';
import { getDateLabel } from '../Utils/EnergyUsagesViewDetailsUtils';

export interface ICommonEnergy {
  onViewDetailsClick?: () => void;
  graphData: ICommomGrapgh;
  dateData: IObject;
  isNILM?: boolean;
}

function CommonEnergyGraphComponent(props: ICommonEnergy) {
  const { onViewDetailsClick, graphData, dateData } = props;
  const { chartSeries, startTime, endTime, aggregationType } = graphData;
  const {
    startMonth,
    startYear,
    endMonth,
    endYear,
    startDate,
    endDate
  } = dateData;
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  return (
    <div className="kpi-card-flex-container">
      <div className="kpi-card-monthwise-container">
        <div className="kpi-card-monthwise-date-range energyGraph">
          {t(d.ENERGYUSAGEDETAILS)}{' '}
          {getDateLabel(
            startMonth,
            endMonth,
            aggregationType,
            startYear,
            endYear,
            startDate,
            endDate
          )}
        </div>
        {props.isNILM ? (
          <PerformanceGraphNILM
            chartSeries={chartSeries}
            startTime={startTime}
            endTime={endTime}
            aggregationType={aggregationType}
            height={'120px'}
            spacing={[
              MAGIC_VALUE.TEN,
              MAGIC_VALUE.TEN,
              MAGIC_VALUE.FIFTEEN,
              MAGIC_VALUE.ZERO
            ]}
            removePadding={true}
          />
        ) : (
          <PerformanceGraph
            chartSeries={chartSeries}
            startTime={startTime}
            endTime={endTime}
            aggregationType={aggregationType}
            height={'120px'}
            spacing={[
              MAGIC_VALUE.TEN,
              MAGIC_VALUE.TEN,
              MAGIC_VALUE.FIFTEEN,
              MAGIC_VALUE.ZERO
            ]}
            removePadding={true}
          />
        )}

        <div className="kpi-card-view-details New-siteDashboard">
          <Button
            type="link"
            content={t(d.VIEWDETAILS)}
            className="view-details-button"
            onClick={
              onViewDetailsClick ? () => onViewDetailsClick() : undefined
            }
          />
        </div>
      </div>
    </div>
  );
}

export default CommonEnergyGraphComponent;
